/**
 * Resolve consumer operational flow from backend service configuration.
 */

export const FLOW_EXISTING = 'existing';
export const FLOW_BROADCAST = 'broadcast';

export function resolveConsumerFlow(config) {
  if (!config || typeof config !== 'object') {
    return FLOW_EXISTING;
  }
  const flow = config.consumer_flow;
  if (flow === FLOW_BROADCAST || flow === FLOW_EXISTING) {
    return flow;
  }
  const enabled = config.enabled ?? config.broadcast_enabled;
  const mode = config.operation_mode
    || (config.consumer_mode === 'broadcast' ? 'broadcast' : 'existing');
  if (!enabled) return FLOW_EXISTING;
  if (enabled && mode === 'broadcast') return FLOW_BROADCAST;
  return FLOW_EXISTING;
}

export function isBroadcastFlow(config) {
  return resolveConsumerFlow(config) === FLOW_BROADCAST;
}
